import { useMutation } from '@tanstack/react-query';
import {
  OilStoreTypeService,
  UploadTransactionImageDto,
  UploadTransactionImageEntity,
} from 'services/openapi';

export type UploadOilTypeAvatarType = {
  param: UploadTransactionImageDto;
};

export const useUploadOilTypeLogoMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<
      UploadTransactionImageEntity,
      Error,
      UploadOilTypeAvatarType & { file: File }
    >({
      mutationFn: (request: UploadOilTypeAvatarType) => {
        return OilStoreTypeService.oilStoreTypeControllerUploadLogo(
          request.param,
        );
      },
      onSuccess: async (data, { file }) => {
        const { sasUrl } = data;

        try {
          const res = await fetch(sasUrl, {
            method: 'PUT',
            headers: {
              'Content-Type': file.type,
              'x-ms-blob-type': 'BlockBlob',
            },
            body: file,
          });

          if (!res.ok) {
            throw error;
          }

          return data;
        } catch (error) {
          throw error;
        }
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
